'use strict';

var xpath = module.exports = {};

// only exists so we can stub get-xpath for testing
xpath._getXPath = require('get-xpath');

xpath._addXPath = function (trackingType, payload, target) {
  if (trackingType === 'click' || trackingType === 'focus' || trackingType === 'capture') {
    var tags = payload.tags || [];
    var xPath = xpath._getXPath(target);
    tags = tags.concat({
      name: 'x_path',
      string: xPath
    });
    payload.tags = tags;
  }
};